


























import { Component, Vue, Prop } from 'vue-property-decorator'
import GoodSelect from '@/components/goods-select/index.vue'
@Component({
  components: {
    GoodSelect,
  },
})
export default class BuyGetGiveaway extends Vue {
  @Prop({
    type: Object,
    required: true,
    default: () => {
      return {
        quantity: 0,
        products: [],
        memberScope: 'All',
        cumulativeWithOtherDiscount: false,
      }
    },
  })
  value!: any

  columns = [
    {
      title: '商品名称',
      width: 450,
      key: 'productName',
    },
    {
      title: '货号',
      key: 'productCode',
    },
    {
      title: '售价',
      key: 'price',
    },
    {
      title: '操作',
      width: 100,
      slot: 'action',
    },
  ]
  data = []
  get selectedItems() {
    return this.value.products.map((x) => x.productId)
  }
  goodsOnChange(e) {
    this.value.products = e.map((x) => {
      return {
        productId: x.id,
        pictureUrl: x.pictureUrl,
        productName: x.name,
        brandName: x.brandName,
        productCode: x.code,
        marketPrice: x.marketPrice,
        price: x.price,
      }
    })
  }
  deleteProduct(index) {
    this.value.products.splice(index, 1)
  }
}
